module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "frontmatter"
    }
  }, [_c('p', {
    staticClass: "centerf"
  }, [_vm._v("Praise for")]), _vm._v(" "), _c('figure', {
    staticClass: "image"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_i",
      "title": "i"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f000i-01.jpg"
    }
  }), _vm._v(" "), _c('figcaption')])]), _vm._v(" "), _c('p', {
    staticClass: "centerf1"
  }, [_vm._v("“A Hollywood adventure that’s truly out of this world! "), _c('em', [_vm._v("Alien Superstar")]), _vm._v(" has it all . . . action, suspense, and big laughs!”")]), _vm._v(" "), _c('p', {
    staticClass: "centerfr"
  }, [_vm._v("—Jeff Kinney, author of the Diary of a Wimpy Kid series")]), _vm._v(" "), _c('p', {
    staticClass: "centerf1"
  }, [_vm._v("“Henry Winkler and Lin Oliver keep us laughing while slipping in a lesson for kids—accept everyone as they are, even if they have suction cups for feet . . . A super fun read.”")]), _vm._v(" "), _c('p', {
    staticClass: "centerfr"
  }, [_vm._v("—Jennifer Garner")]), _vm._v(" "), _c('p', {
    staticClass: "centerf1"
  }, [_vm._v("“Out of this world . . . will resonate with any kid who has felt like an outsider.”")]), _vm._v(" "), _c('p', {
    staticClass: "centerfr"
  }, [_vm._v("—"), _c('em', [_vm._v("Booklist")])]), _vm._v(" "), _c('p', {
    staticClass: "centerf1"
  }, [_vm._v("“A funny interstellar adventure that will have readers watching the cosmos for the second book to arrive.”")]), _vm._v(" "), _c('p', {
    staticClass: "centerfr"
  }, [_vm._v("—"), _c('em', [_vm._v("School Library Journal")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-45dff8ee","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/fm01.vue
// module id = 57
// module chunks = 0